/* src/app/common/components/header/header.component.scss */
:root {
  --ion-color-primary: #356859;
  --ion-color-primary-rgb:
    53,
    104,
    89;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb:
    255,
    255,
    255;
  --ion-color-primary-shade: #142721;
  --ion-color-primary-tint: #498f7a;
  --ion-color-secondary: #f3ad6a;
  --ion-color-secondary-rgb:
    243,
    173,
    106;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb:
    255,
    255,
    255;
  --ion-color-secondary-shade: #f2a358;
  --ion-color-secondary-tint: #f7cda5;
  --ion-color-tertiary: #22254c;
  --ion-color-tertiary-rgb:
    34,
    37,
    76;
  --ion-color-tertiary-contrast: #ffffff;
  --ion-color-tertiary-contrast-rgb:
    255,
    255,
    255;
  --ion-color-tertiary-shade: #14162d;
  --ion-color-tertiary-tint: #7a7c93;
  --ion-color-success: #2dd36f;
  --ion-color-success-rgb:
    45,
    211,
    111;
  --ion-color-success-contrast: #ffffff;
  --ion-color-success-contrast-rgb:
    255,
    255,
    255;
  --ion-color-success-shade: #28ba62;
  --ion-color-success-tint: #42d77d;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb:
    255,
    196,
    9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb:
    0,
    0,
    0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #eb445a;
  --ion-color-danger-rgb:
    235,
    68,
    90;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb:
    255,
    255,
    255;
  --ion-color-danger-shade: #cf3c4f;
  --ion-color-danger-tint: #ed576b;
  --ion-color-dark: #222428;
  --ion-color-dark-rgb:
    34,
    36,
    40;
  --ion-color-dark-contrast: #ffffff;
  --ion-color-dark-contrast-rgb:
    255,
    255,
    255;
  --ion-color-dark-shade: #1e2023;
  --ion-color-dark-tint: #383a3e;
  --ion-color-medium: #92949c;
  --ion-color-medium-rgb:
    146,
    148,
    156;
  --ion-color-medium-contrast: #ffffff;
  --ion-color-medium-contrast-rgb:
    255,
    255,
    255;
  --ion-color-medium-shade: #808289;
  --ion-color-medium-tint: #9d9fa6;
  --ion-color-light: #f4f5f8;
  --ion-color-light-rgb:
    244,
    245,
    248;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb:
    0,
    0,
    0;
  --ion-color-light-shade: #d7d8da;
  --ion-color-light-tint: #f5f6f9;
  --ion-color-link: #428cff;
  --ion-color-link-rgb:
    66,
    140,
    255;
  --ion-color-link-contrast: #ffffff;
  --ion-color-link-contrast-rgb:
    255,
    255,
    255;
  --ion-color-link-shade: #3a7be0;
  --ion-color-link-tint: #5598ff;
  --ion-color-tile: #295b55;
  --ion-color-tile-rgb:
    58,
    63,
    75;
  --ion-color-tile-contrast: #ffffff;
  --ion-color-tile-contrast-rgb:
    255,
    255,
    255;
  --ion-color-tile-shade: #275450;
  --ion-color-tile-tint: #2a6360;
  --ion-color-steel: #4682b4;
  --ion-color-steel-rgb:
    70,
    130,
    180;
  --ion-color-steel-contrast: #ffffff;
  --ion-color-steel-contrast-rgb:
    255,
    255,
    255;
  --ion-color-steel-shade: #3b6d97;
  --ion-color-steel-tint: #5b94c0;
  --ion-color-neutral: #888888;
  --ion-color-neutral-rgb:
    136,
    136,
    136;
  --ion-color-neutral-contrast: #ffffff;
  --ion-color-neutral-contrast-rgb:
    255,
    255,
    255;
  --ion-color-neutral-shade: #7a7a7a;
  --ion-color-neutral-tint: #999999;
  --ion-color-dark-gray: #333333;
  --ion-color-dark-gray-rgb:
    51,
    51,
    51;
  --ion-color-dark-gray-contrast: #ffffff;
  --ion-color-dark-gray-contrast-rgb:
    255,
    255,
    255;
  --ion-color-dark-gray-shade: #2d2d2d;
  --ion-color-dark-gray-tint: #4d4d4d;
  --ion-color-light-gray: #cccccc;
  --ion-color-light-gray-rgb:
    204,
    204,
    204;
  --ion-color-light-gray-contrast: #000000;
  --ion-color-light-gray-contrast-rgb:
    0,
    0,
    0;
  --ion-color-light-gray-shade: #b8b8b8;
  --ion-color-light-gray-tint: #d9d9d9;
  --side-menu-width: 250px;
  --side-menu-collapsed-width: 60px;
  --font-base: "Open Sans", sans-serif;
  --font-raleway: "Raleway", sans-serif;
  --font-staaliches: "Staatliches", sans-serif;
}
ion-card {
  --card-border-radius: 3px;
}
ion-button {
  --border-width: 1px;
  --border-radius: 3px;
}
ion-toolbar.in-toolbar {
  --background: var(--ion-color-primary);
  --min-height: 56px;
}
ion-toolbar.in-toolbar ion-button.button {
  --color: var(--ion-color-primary-contrast);
}
ion-title {
  color: var(--ion-color-secondary);
  padding: 0 4px;
}
ion-title .logo {
  height: 2rem;
  vertical-align: bottom;
}
ion-title .title {
  font-family: "Staatliches";
  color: var(--ion-color-secondary);
  letter-spacing: 5px;
  vertical-align: text-top;
  line-height: 30px;
}
ion-title .title .dine {
  color: var(--ion-color-tertiary);
}
.language-chooser {
  color: var(--ion-color-primary-contrast);
}
@media only screen and (max-width: 400px) {
  .title {
    display: none;
  }
}
.w-150px {
  width: 150px;
}
.max-h-75px {
  max-height: 75px !important;
}
ion-button.btn-notification {
  position: relative;
  --padding-start: 0;
  --padding-end: 0;
}
ion-button.btn-notification ion-badge.notify-badge {
  position: absolute;
  top: -5px;
  right: 10px;
  z-index: 1;
  color: #f1f1f1;
}
@media screen and (max-width: 765px) {
  .live-kitchen-btn {
    display: none;
  }
}
/*# sourceMappingURL=header.component.css.map */
